'use client'

import { createContext, useContext } from 'react'

import { type OpenableControls } from '../../../generic-hooks'

export type SellerModalContextValue = {
  openableControls: OpenableControls
  productUpid: string
  sellerId: string
  showSellerModal: (parameters: {
    productUpid: string
    sellerId: string
  }) => void
}

export const SellerModalContext = createContext<
  SellerModalContextValue | undefined
>(undefined)

export const useSellerModalContext = (): SellerModalContextValue => {
  const contextValue = useContext(SellerModalContext)

  if (contextValue === undefined) {
    throw new Error(
      'useSellerModalContext must be used within a SellerModalContext',
    )
  }

  return contextValue
}
